import { observable, action, makeAutoObservable, computed } from "mobx";
import { IsMobile } from "../utils/helpers";

class UICartStore {
    private _open: boolean = false;
    private _hasEverBeenOpened: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }

    @computed get open() {
        return this._open;
    }

    @computed get hasEverBeenOpened() {
        return this._hasEverBeenOpened || IsMobile();
    }

    @action setOpen(open: boolean) {
        this._open = open;
        this.setHasEverBeenOpened(true);
    }

    @action setHasEverBeenOpened(hasEverBeenOpened: boolean) {
        this._hasEverBeenOpened = hasEverBeenOpened;
    }
}

export default new UICartStore();
